/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import * as Sentry from "@sentry/react";

import styled from "@emotion/styled";

import Dialog from "@material-ui/core/Dialog";
import ToolbarButton from "components/ToolbarButton";

import t from "translations";
import HelpIcon from "@material-ui/icons/Help";

import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { faq } from "externalData";

const StyledDialogTitle = styled(DialogTitle)`
  h2 {
    line-height: 50px;
    font-size: 28px;
    text-align: center;
  }
`;

const Preview = props => {
  return (
    <Dialog
      open={props.isVisible}
      maxWidth={"xl"}
      fullWidth
      scroll="paper"
      onEscapeKeyDown={props.onClose}
    >
      <StyledDialogTitle
        style={{ lineHeight: 50, fontSize: 28, textAlign: "center" }}
      >
        {t.FAQ}
        <IconButton
          style={{ float: "right" }}
          edge="start"
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent dividers>
        <DialogContentText
          tabIndex={-1}
          dangerouslySetInnerHTML={{ __html: faq }}
        ></DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

const PreviewDebugger = props => {
  const [preview, setPreview] = useState(false);

  return (
    <React.Fragment>
      <Preview isVisible={preview} onClose={() => setPreview(false)} />
      <ToolbarButton
        dark
        onClick={() => {
          setPreview(true);
        }}
        vertical
        desc={t.FAQ}
        icon={<HelpIcon />}
      />
      <ToolbarButton
        dark
        onClick={() => {
          Sentry.showReportDialog({lang: 'de', eventId: Sentry.captureMessage('support') });
        }}
        vertical
        desc="Support"
        icon={<HelpIcon />}
      />
    </React.Fragment>
  );
};

export default PreviewDebugger;
